module.exports = __webpack_public_path__ + "images/a075ea5ca66b5a35492bbd17f6824ec6-IMG_8129.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8129.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8129.jpg
// module chunks = 0